module.exports = __webpack_public_path__ + "img/bearbeiten.31d16c58.svg";